import EXIF from "exif-js";

export const orientation = (img) => {
  return new Promise(function (resolve, reject) {
    EXIF.getData(img, () => {
      var allMetaData = EXIF.getAllTags(img);
      let orientation = allMetaData.Orientation;
      resolve(orientation);
    });
  });
};

export const resizeImage = (file, maxW, maxH) => {
  return new Promise((resolve, reject) => {
    try {
      const img = document.createElement("img");
      img.onload = async () => {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var iw = img.width;
        var ih = img.height;
        var exifOrientation = "";
        // Bypassing use of orientation by adding 20 ...
        exifOrientation = 20 + (await orientation(img));
        let scale = 1;
        if (iw > maxW || ih > maxH) {
          scale = Math.min(maxW / iw, maxH / ih);
        }
        var iwScaled = Math.round(iw * scale);
        var ihScaled = Math.round(ih * scale);
        if ([5, 6, 7, 8].indexOf(exifOrientation) > -1) {
          canvas.width = ihScaled;
          canvas.height = iwScaled;
        } else {
          canvas.width = iwScaled;
          canvas.height = ihScaled;
        }
        switch (exifOrientation) {
          case 2:
            ctx.setTransform(-1, 0, 0, 1, iwScaled, 0);
            break;
          case 3:
            ctx.setTransform(-1, 0, 0, -1, iwScaled, ihScaled);
            break;
          case 4:
            ctx.setTransform(1, 0, 0, -1, 0, ihScaled);
            break;
          case 5:
            ctx.setTransform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.setTransform(0, 1, -1, 0, ihScaled, 0);
            break;
          case 7:
            ctx.setTransform(0, -1, -1, 0, ihScaled, iwScaled);
            break;
          case 8:
            ctx.setTransform(0, -1, 1, 0, 0, iwScaled);
            break;
          default:
            ctx.setTransform(1, 0, 0, 1, 0, 0);
        }
        ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
        var dataURI = canvas.toDataURL();
        resolve(dataURI);
      };
      img.src = file;
    } catch (error) {
      reject(error);
    }
  });
};

export const imageToThumb = (file, maxThumb) => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onloadend = async () => {
        let thumbnail = await resizeImage(reader.result, maxThumb, maxThumb);
        resolve(thumbnail);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      reject(error);
    }
  });
};
